export default __webpack_public_path__ + "static/media/img5.72172c46.jfif";